require("!!/root/xmpp-web/node_modules/script-loader/addScript.js")(require("!!/root/xmpp-web/node_modules/script-loader/node_modules/raw-loader/index.js!/root/xmpp-web/node_modules/strophejs-plugins/caps/strophe.CAPS.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/strophejs-plugins/caps/strophe.CAPS.js
 ** module id = 15
 ** module chunks = 0
 **/